import { createSlice } from "@reduxjs/toolkit";

const AuthSlice = createSlice({
    name: "auth",
    
    initialState: {
        customer: localStorage.customer ? JSON.parse(localStorage.customer) : {},
        isLoggedIn: !!localStorage.customer
    },

    reducers: {
        LoggedIn: ( state, action ) => {
            state.customer = action.payload
            state.isLoggedIn = true

            window.localStorage.setItem("customer", JSON.stringify(action.payload))
            
        },

        LoggedOut: (state, action) => {
            state.customer = {}
            state.isLoggedIn = false

            window.localStorage.clear()
        }
    }
})

export const { LoggedIn, LoggedOut } = AuthSlice.actions
export default AuthSlice.reducer;